module.exports = __webpack_public_path__ + "static/media/1f931d8a393fd5d09b1845dd40ecafe.2cdb0aaf.jpg";